<template>
    <div class="row-in-form">
        <label v-if="type !== 'hidden'" :for="inputId">{{ label }} <span v-if="inputVar.required">*</span></label>



        <!-- Input select -->
        <div v-if="type === 'select'">
            <vue-select
                :id="inputId"
                v-model="inputVar.value"
                :options="options"
                :select-on-tab="true"
                :placeholder="getPlaceholder()"
                :readonly="!!readonly"
                :class="{ 'is-invalid': !inputVar.validation.status && form.attemptSubmit }"
                :disabled="!!disabled"
                @input="change"
                >
                    <span slot="no-options">Nenhum resultado.</span>
            </vue-select>
        </div>

        <!-- datetime picker -->
        <div v-else-if="type === 'picker'">
            <datetime v-model="inputVar.value" :input-id="inputId" type="date" format="dd/MM/yyyy" value-zone="local" :readonly="!!readonly">
                <template slot="button-confirm">
                    <i class="fa fa-check-circle"></i>
                    OK
                </template>
                <template slot="button-cancel">
                    <i class="fa fa-times"></i>
                    Cancelar
                </template>
            </datetime>
        </div>

        <!-- Input File -->
        <div v-else-if="type === 'file'">
            <div :id="inputId" class="wrapper-file" style="cursor: pointer;">
                <div class="file-container">
                    <label :for="inputId + '-files'"><i class="fa fa-upload"></i><u v-if="!inputVar.value" class="align-center file-name">{{getPlaceholder()}}</u><div class="file-name" ref="nameFile"></div><a class="fa fa-times" v-on:click.prevent="clearFile" href="#" ref="removeFile" /></label>
                </div>
                <input :id="inputId + '-files'"
                       :class="{ 'is-invalid': !inputVar.validation.status && form.attemptSubmit }" :disabled="!!disabled" type="file" @change="selectFile()" ref="myfiles" />
            </div>
        </div>

        <!-- datetime picker -->
        <div v-else-if="type === 'picker'">
            <datetime v-model="inputVar.value" :input-id="inputId" type="date" format="dd/MM/yyyy">
                <template slot="button-confirm">
                    <i class="fa fa-check-circle"></i>
                    OK
                </template>
                <template slot="button-cancel">
                    <i class="fa fa-times"></i>
                    Cancelar
                </template>
            </datetime>
        </div>

        <!-- datetime picker -->
        <div v-else-if="type === 'date'">
            <input v-model="inputVar.value" type="date" :min="min" :max="max" :disabled="!!disabled" :readonly="!!readonly">
        </div>

        <!-- Input File -->
        <div v-else-if="type === 'file'">
            <div :id="inputId" class="wrapper-file">
                <div class="file-container">
                    <label :for="inputId + '-files'">
                        <i class="fa fa-upload"></i>
                        <div class="file-name" ref="nameFile"></div>
                        <a class="fa fa-times" v-on:click.prevent="clearFile" href="#" ref="removeFile" />
                    </label>
                </div>
                <input :id="inputId + '-files'"
                       :placeholder="getPlaceholder()"
                       :class="{ 'is-invalid': !inputVar.validation.status && form.attemptSubmit }"
                       :disabled="!!disabled"
                       type="file"
                       @change="selectFile()"
                       ref="myfiles" />
            </div>
        </div>

        <!-- Input Radio -->
        <div v-else-if="type === 'radio'">
            <label v-for="option in options" :key="option.code" class="inline-radio">
                <input v-if="!change" v-model="inputVar.value"
                       type="radio"
                       :value="option.value"
                       :name="option.label"
                       :disabled="!!disabled"
                       :readonly="!!readonly" />
                <input v-if="!!change" v-model="inputVar.value"
                       type="radio"
                       :value="option.value"
                       :name="option.label"
                       :disabled="!!disabled"
                       :readonly="!!readonly"
                       @change="change" />
                {{option.label}}

                <img v-if="option.img && option.img.src"
                    :src="option.img.src"
                    :height="option.img.height"
                    :width="option.img.width"
                    style="margin-left: 2px; margin-bottom: 8px;"
                    alt="" />
            </label>
        </div>

        <!-- Input Radio -->
        <div v-else-if="type === 'checkbox'">
            <label v-for="option in options" :key="option.code" class="inline-checkbox">
                <input v-model="inputVar.value"
                       type="checkbox"
                       :checked="option.checked"
                       :value="option.value"
                       :name="option.label"
                       :readonly="!!readonly" />
                {{option.label}}
            </label>
        </div>

        <!-- Input Money -->
        <div v-else-if="type ==='money'">
            <money :id="inputId"
                   v-model="inputVar.value"
                   v-bind="moneyConfig"
                   :placeholder="getPlaceholder()"
                   :class="{ 'is-invalid': !inputVar.validation.status && form.attemptSubmit }"
                   :disabled="!!disabled"
                   :readonly="!!readonly" />
        </div>

        <!-- Input com ícone -->
        <div v-else-if="icon !== undefined" class="input-group">
            <!-- Input com máscara -->
            <input v-if="mask !== undefined"
                   :id="inputId"
                   :type="type !== undefined ? type : 'text'"
                   v-mask="mask"
                   v-model="inputVar.value"
                   :placeholder="getPlaceholder()"
                   :class="{ 'is-invalid': !inputVar.validation.status && form.attemptSubmit }"
                   :disabled="!!disabled"
                   :readonly="!!readonly" />
            <!-- Input sem máscara -->
            <input v-else
                   :id="inputId"
                   :type="type !== undefined ? type : 'text'"
                   v-model="inputVar.value"
                   :placeholder="getPlaceholder()"
                   :maxlength="getMaxLength()"
                   :class="{ 'is-invalid': !inputVar.validation.status && form.attemptSubmit }"
                   :disabled="!!disabled"
                   :readonly="!!readonly" />

            <span class="input-group-addon" @click="iconClick" :class="{ hand: isPassword }">
                <i :class="'fa ' + icon"></i>
            </span>
        </div>

        <!-- Input number -->
        <div v-else-if="type === 'number'">
            <input :id="inputId"
                   type="number"
                   :min="min"
                   v-model="inputVar.value"
                   :placeholder="getPlaceholder()"
                   :maxlength="getMaxLength()"
                   :class="{ 'is-invalid': !inputVar.validation.status && form.attemptSubmit }"
                   :disabled="!!disabled"
                   :readonly="!!readonly" />
        </div>

        <!-- Input range -->
        <div v-else-if="type === 'range'">
            <input :id="inputId"
                   type="range"
                   :min="min"
                   :max="max"
                   :step="step"
                   v-model="inputVar.value"
                   :placeholder="getPlaceholder()"
                   style="padding: 0"
                   :class="{
          'is-invalid': !inputVar.validation.status && form.attemptSubmit,
          'custom-range': true,
        }"
                   :disabled="!!disabled"
                   :readonly="!!readonly" />
        </div>

        <!-- datetime picker -->
        <div v-else-if="type === 'daterange'">
            <input v-model="inputVar.value"
                   type="date"
                   :min="min"
                   :max="max"
                   :disabled="!!disabled"
                   :readonly="!!readonly" />
        </div>

        <!-- Input textarea -->
        <div v-else-if="type ==='textarea'">
            <textarea class="form-control"
                      style="resize: vertical"
                      :id="inputId"
                      v-model="inputVar.value"
                      :rows="getTextAreaRows()"
                      :placeholder="getPlaceholder()"
                      :maxlength="getMaxLength()"
                      :class="{ 'is-invalid': !inputVar.validation.status && form.attemptSubmit }"
                      :disabled="!!disabled"
                      :readonly="!!readonly"
                      @blur="getBlurEvent()"/>
        </div>

        <!-- Input sem ícone -->
        <div v-else-if="type ==='cep'" class="input-group">
            <!-- Input com máscara -->
            <input :id="inputId"
                   :type="type !== undefined ? type : 'text'"
                   v-mask="mask"
                   v-model="inputVar.value"
                   :placeholder="getPlaceholder()"
                   :class="{ 'form-control':true, 'is-invalid': !inputVar.validation.status && (form.attemptSubmit || (form.cnpjInvalid && validationType == 'cnpj')) }"
                   :disabled="!!disabled"
                   :readonly="!!readonly"
                   @blur="getBlurEvent()" />
            <span class="input-group-btn">
                <button class="btn btn-default" type="button"><i class="fa fa-check"></i></button>
            </span>
        </div>


        <!-- Input sem ícone -->
        <div v-else>
            <!-- Input com máscara -->
            <input v-if="mask !== undefined"
                   :id="inputId"
                   :type="type !== undefined ? type : 'text'"
                   v-mask="mask"
                   v-model="inputVar.value"
                   :placeholder="getPlaceholder()"
                   :class="{ 'is-invalid': !inputVar.validation.status && (form.attemptSubmit || (form.cnpjInvalid && validationType == 'cnpj')) }"
                   :disabled="!!disabled"
                   :readonly="!!readonly"
                   @blur="getBlurEvent()" />
            <!-- Input sem máscara -->
            <input v-else
                   :id="inputId"
                   :type="type !== undefined ? type : 'text'"
                   v-model="inputVar.value"
                   :placeholder="getPlaceholder()"
                   :maxlength="getMaxLength()"
                   :class="{ 'is-invalid': !inputVar.validation.status && (form.attemptSubmit || (form.cnpjInvalid && validationType == 'cnpj')) }"
                   :disabled="!!disabled"
                   :readonly="!!readonly"
                   @blur="getBlurEvent()" />
        </div>
        <span v-if="linkInLabel" v-html="linkInLabel"></span>
        <span v-if="!inputVar.validation.status && (form.attemptSubmit || (form.cnpjInvalid && validationType == 'cnpj'))"
              class="invalid-feedback">{{ inputVar.validation.message }}</span>
    </div>
</template>

<style>

.hand {
    cursor: pointer;
}
</style>

<script>
    export default {
        name: 'FormHelper',
        props: [
            'step',
            'readonly',
            'inputVar',
            'placeholder',
            'form',
            'label',
            'mask',
            'type',
            'disabled',
            'icon',
            'validationType',
            'options',
            'compareTo',
            'id',
            'fileTypes',
            'rows',
            'lostFocus',
            'maxlength',
            'max',
            'min',
            'linkInLabel',
            'change',
        ],
        data() {
            return {
                isPassword: false,
                moneyConfig: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    precision: 2,
                    masked: false
                }
            }
        },
        computed: {
            inputId: function () {
                // Caso tenha um ID, ele retorna. Caso não tenha, ele gera um id baseado na label
                return this.id ? this.id : this.convertLabelToId(this.label)
            }
        },
        mounted() {
            this.validateInput(this.inputVar.value)
            this.isPassword = this.type == 'password';
        },
        watch: {
            'inputVar.value': function (val) {
                if (this.type == 'file' && (val === '' || val === null)) {
                    this.removeNameFile()
                }
                this.validateInput(val)
            },
            'compareTo.value': function () {
                this.validateInput(this.inputVar.value)
            }
        },
        methods: {
            formataNumero: function (value, decimals = 2) {
                if (!value && value !== 0) {
                    return "";
                }
                let val = (value / 1).toFixed(decimals).replace(".", ",");
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            },
            convertLabelToId: function (text) {
                // Remove acentos e espaços do label para usar como ID
                text = text.toLowerCase()
                text = text.replace(/ /g, '-')
                text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a')
                text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e')
                text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i')
                text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o')
                text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u')
                text = text.replace(new RegExp('[Ç]', 'gi'), 'c')

                return text
            },
            getPlaceholder: function () {
                if (this.placeholder !== undefined)
                    // Retorna placeholder caso ele esteja definido
                    return this.placeholder
                // Cria um placeholder com base na label
                else return this.inputVar.required ? this.label + ' *' : this.label
            },
            getMaxLength: function () {
                if (this.maxlength !== undefined)
                    return this.maxlength
                else
                    return "1000000"
            },
            getBlurEvent: function () {
                // // console.log(this.lostFocus);
                if (this.lostFocus !== undefined)
                    return this.lostFocus();
                else return this.blurFake;
            },
            blurFake: function () { },

            getTextAreaRows: function () {
                if (this.rows !== undefined) {
                    return this.rows
                } else {
                    return '5'
                }
            },
            validateInput: function (val) {
                // Verifica se o campo é obrigatório
                if (this.inputVar.required) {
                    // Verifica se não está preenchido
                    if (val === '' || val === null || val === undefined || val.length == 0) {
                        this.inputVar.validation = this.buildError(
                            'Por favor, preencha o campo acima'
                        )
                    }
                    else this.validate(val)
                } else {
                    // Valida apenas se tiver um valor
                    if (val) this.validate(val)
                    else this.inputVar.validation.status = true
                }
            },

            iconClick: function (val) {
                if (this.isPassword) {
                    this.type = this.type == 'password' ? 'text' : 'password';
                    this.icon = this.type == 'password' ? 'fa-eye' : 'fa-eye-slash';
                }
            },

            validate: function (val) {
                // Regex para validação
                let re;

                if (this.validationType) {
                    switch (this.validationType) {
                        case "daterange":
                            re = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
                            if (!re.test(val)) {
                                this.inputVar.validation = this.buildError("Data inválida");
                            } else {
                                let newDate = new Date(val);
                                let minDate = new Date(this.min);
                                let maxDate = new Date(this.max);

                                if (newDate > maxDate || newDate < minDate) {
                                    this.inputVar.validation = this.buildError(
                                        "Favor informar uma data entre " +
                                        minDate.toLocaleDateString("pt-BR", {
                                            timeZone: "UTC",
                                            day: "numeric",
                                            month: "numeric",
                                            year: "numeric",
                                        }) +
                                        " e " +
                                        maxDate.toLocaleDateString("pt-BR", {
                                            timeZone: "UTC",
                                            day: "numeric",
                                            month: "numeric",
                                            year: "numeric",
                                        }) +
                                        "."
                                    );
                                } else {
                                    this.inputVar.validation.status = true;
                                }
                            }
                            break;

                        case "rangeValue":
                            if (val != null) {
                                let newValue = parseFloat(val);
                                let minValue = parseFloat(this.min);
                                let maxValue = parseFloat(this.max);

                                if (newValue > maxValue || newValue < minValue) {
                                    this.inputVar.validation = this.buildError(
                                        "Favor informar um valor entre " +
                                        this.formataNumero(minValue) +
                                        " e " +
                                        this.formataNumero(maxValue) +
                                        "."
                                    );
                                } else {
                                    this.inputVar.validation.status = true;
                                }
                            }
                            break;

                        case 'cpf':
                            val = this.clearString(val);

                            if (!this.testCpf(val)) {
                                this.inputVar.validation = this.buildError('O CPF preenchido é inválido');
                            } else {
                                this.inputVar.validation.status = true;
                            }
                            break;

                        case 'cnpj':
                            re = /([0-9]{2}[\.]?[0-9]{3}[\.]?[0-9]{3}[\/]?[0-9]{4}[-]?[0-9]{2})/;

                            if (!re.test(val) || !this.testCnpj(val)) {
                                this.inputVar.validation = this.buildError('O CNPJ preenchido é inválido');
                            } else {
                                this.inputVar.validation.status = true;
                            }
                            break;

                        case 'cep':
                            re = /^[0-9]{8}$/;

                            // Remove characteres especiais do CEP
                            val = this.clearString(val);

                            if (!re.test(val)) {
                                this.inputVar.validation = this.buildError('O CEP preenchido é inválido');
                            } else {
                                this.inputVar.validation.status = true;
                            }
                            break;

                        case 'rg':

                            break;

                        case 'phone':
                            re = /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$/;

                            if (!re.test(val)) {
                                this.inputVar.validation = this.buildError('Telefone inválido');
                            } else {
                                this.inputVar.validation.status = true;
                            }
                            break;

                        case 'telefone':
                            if (val.length < 14) {
                                this.inputVar.validation = this.buildError('Telefone inválido');
                            }
                            else {
                                this.inputVar.validation.status = true;
                            }
                            break;

                        case 'email':
                            re = /^[\w-']+(\.[\w-']+)*@([a-z0-9-]+(\.[a-z0-9-]+)*?\.[a-z]{2,6}|(\d{1,3}\.){3}\d{1,3})(:\d{4})?$/;
                            if (!re.test(val) || val.match(/['"]+/g)) {
                                this.inputVar.validation = this.buildError('E-mail inválido');
                            }
                            else if (val.length > 50) {
                                this.inputVar.validation = this.buildError('Máximo de 50 caracteres');
                            }
                            else {
                                this.inputVar.validation.status = true;
                            }
                            break;
                        case 'password':
                            re = /(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/;
                            if (!re.test(val) || val.match(/['"]+/g)) {
                                this.inputVar.validation = this.buildError('Senha inválida, a senha não atende a todos requisitos solicitados.');
                            }
                            else if (val.length < 6) {
                                this.inputVar.validation = this.buildError('Mínimo de 6 caracteres');
                            }
                            else {
                                this.inputVar.validation.status = true;
                            }
                            break;

                        case 'password-minlength':
                            if (this.inputVar.value.length < 6) {
                                this.inputVar.validation = this.buildError('A senha deve ter no mínimo 6 caracteres');
                            } else {
                                this.inputVar.validation.status = true;
                            }
                            break;

                        // Para validar qualquer data
                        case 'date':
                            re = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;

                            if (!re.test(val)) {
                                this.inputVar.validation = this.buildError('Data inválida');
                            } else {
                                let inputDate = new Date(val);
                                let todayDate = new Date();

                                if (inputDate.setHours(0, 0, 0, 0) >= todayDate.setHours(0, 0, 0, 0)) {
                                    this.inputVar.validation = this.buildError('Não é permitido adicionar uma data futura');
                                } else {
                                    this.inputVar.validation.status = true;
                                }
                            }
                            break;
                        // Para validar uma data que está no passado (não pode ser > que a data atual)
                        case 'pastDate':
                            re = /([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}/;

                            // Verifica se data é inválida
                            if (!re.test(val)) {
                                this.inputVar.validation = this.buildError('Data inválida');
                            } else {
                                // Caso seja válida, verifica se é uma data futura
                                const date = val.split('/')
                                const inputDate = new Date(`${date[1]}/${date[0]}/${date[2]}`); // MM/DD/YYYY
                                const todayDate = new Date();

                                // Seta as horas para não serem consideradas na comparação
                                if (inputDate.setHours(0, 0, 0, 0) > todayDate.setHours(0, 0, 0, 0)) {
                                    this.inputVar.validation = this.buildError('Não é permitido adicionar uma data futura');
                                } else {
                                    this.inputVar.validation.status = true;
                                }
                            }
                            break;

                        case 'pastDate2':
                            //re = /([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}/;

                            // Verifica se data é inválida
                            // if (!re.test(val)) {
                            //     this.inputVar.validation = this.buildError('Data inválida');
                            // } else {
                            // Caso seja válida, verifica se é uma data futura
                            const d = val.split('T')
                            const date = d[0].split('-')
                            const inputDate = new Date(`${date[0]}/${date[1]}/${date[2]}`); // YYYY/MM/DD
                            const todayDate = new Date();

                            // Seta as horas para não serem consideradas na comparação
                            if (inputDate.setHours(0, 0, 0, 0) > todayDate.setHours(0, 0, 0, 0)) {
                                this.inputVar.validation = this.buildError('Não é permitido adicionar uma data futura');
                            } else {
                                this.inputVar.validation.status = true;
                            }
                            //}
                            break;

                        // Nesse caso, o input valida se o valor é igual ao input preenchido anteriormente
                        // Ex: Confirmação de e-mail / senha
                        case 'comparison':
                            if (val !== this.compareTo.value) {
                                this.inputVar.validation = this.buildError('Os valores não coincidem');
                            } else {
                                this.inputVar.validation.status = true;
                            }
                            break;

                        case 'website':
                            re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;

                            if (!re.test(val)) {
                                this.inputVar.validation = this.buildError('Website inválido');
                            } else {
                                this.inputVar.validation.status = true;
                            }
                            break;
                        case 'Negative':
                            if (parseFloat(val) <= 0) {
                                this.inputVar.validation = this.buildError('O valor não pode ser menor ou igual do que 0');
                            } else {
                                this.inputVar.validation.status = true;
                            }
                            break;

                        case 'Negative2':
                            if (parseFloat(val) < 0) {
                                this.inputVar.validation = this.buildError('O valor não pode ser menor negativo');
                            } else {
                                this.inputVar.validation.status = true;
                            }
                            break;
                        case 'creditCard':
                            this.checkCredCard(val);
                            break;
                        case 'validateDateCard':
                            this.checkValidadeCard(val)
                            break;
                        case 'name':
                            let name = val.trim().split(' ');

                            if (name.length > 1 && name[1].length > 1)
                                this.inputVar.validation.status = true;
                            else
                                this.inputVar.validation = this.buildError('É necessário ter no mínimo nome e sobrenome');
                            break;
                        case 'billingSantander':
                            if (val > 0 && val < 199999)
                                this.inputVar.validation.status = true;
                            else if (val < 1)
                                this.inputVar.validation = this.buildError('Por favor, preencha o campo acima');
                            else
                                this.inputVar.validation = this.buildError('O faturamento mensal não pode ser maior que R$ 199.999,00');
                            break;
                        case 'quotes':
                            if (val.match(/['",]+/g))
                                this.inputVar.validation = this.buildError('Campos de texto não podem conter aspas e vírgulas');
                            else
                                this.inputVar.validation.status = true;
                            break;
                    }
                } else {
                    this.inputVar.validation.status = true
                }
            },
            testCnpj: function (c) {
                var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

                if ((c = c.replace(/[^\d]/g, '')).length != 14) return false

                if (/0{14}/.test(c)) return false

                for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
                if (c[12] != ((n %= 11) < 2 ? 0 : 11 - n)) return false

                for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
                if (c[13] != ((n %= 11) < 2 ? 0 : 11 - n)) return false

                return true
            },
            testCpf: function (cpf) {
                var numbers, digits, sum, i, result, similar_digits

                similar_digits = 1

                if (cpf.length < 11) return false

                for (i = 0; i < cpf.length - 1; i++)
                    if (cpf.charAt(i) != cpf.charAt(i + 1)) {
                        similar_digits = 0
                        break
                    }

                if (!similar_digits) {
                    numbers = cpf.substring(0, 9)
                    digits = cpf.substring(9)
                    sum = 0
                    for (i = 10; i > 1; i--) sum += numbers.charAt(10 - i) * i
                    result = sum % 11 < 2 ? 0 : 11 - (sum % 11)
                    if (result != digits.charAt(0)) return false
                    numbers = cpf.substring(0, 10)
                    sum = 0
                    for (i = 11; i > 1; i--) sum += numbers.charAt(11 - i) * i
                    result = sum % 11 < 2 ? 0 : 11 - (sum % 11)
                    if (result != digits.charAt(1)) return false
                    return true
                } else return false
            },
            buildError: function (msg) {
                // Escreve o erro no formato padrão e retorna
                return { status: false, message: msg }
            },
            clearString: function (str) {
                // Remove characteres especiais da string
                return str.replace(/[^\d]/g, '')
            },
            selectFile: function () {
                if (this.$refs.myfiles.files.length > 0) {
                    const self = this
                    const file = this.$refs.myfiles.files[0]
                    const reader = new FileReader()
                    let base64 = ''
                    reader.readAsDataURL(file)

                    reader.onloadend = function () {
                        base64 = reader.result.replace('data:' + file.type + ';base64,', '')
                        self.$set(self.inputVar, 'value', base64)
                        self.$set(self.inputVar, 'name', file.name)
                        self.$set(self.inputVar, 'tipo', file.type.split('/')[1])
                        self.$set(self.inputVar, 'size', file.size)
                    }
                    if (this.fileTypes) {
                        if (!this.fileTypes.includes(file.name.split('.').pop())) {
                            alert(
                                'Utilizar somente arquivos dos tipos: ' + this.fileTypes.join(',')
                            )
                            return
                        }
                    }
                    this.$refs.nameFile.innerHTML = file.name
                    this.$refs.removeFile.style.display = 'block'
                }
            },
            clearFile: function () {
                this.$set(this.inputVar, 'name', '')
                this.$set(this.inputVar, 'value', '')
            },
            removeNameFile: function () {
                this.$refs.nameFile.innerHTML = ''
                this.$refs.removeFile.style.display = 'none'
                this.$refs.myfiles.value = '';
            },
            replaceAll: function (string, token, newtoken) {
                while (string.indexOf(token) != -1)
                    string = string.replace(token, newtoken);
                return string;
            },
            checkCredCard: function (numero) {
                var msg = Array();
                var tipo = null;
                numero = this.replaceAll(numero, ' ', '');

                if (numero.length > 16 || numero[0] == 0)
                    return this.inputVar.validation = this.buildError('Cartão Inválido')
                else {
                    var total = 0;
                    var arr = Array();
                    let dig, dig1, dig2;

                    for (let i = 0; i < numero.length; i++) {
                        if (i % 2 == 0) {
                            dig = numero[i] * 2;

                            if (dig > 9) {
                                dig1 = dig.toString().substr(0, 1);
                                dig2 = dig.toString().substr(1, 1);
                                arr[i] = parseInt(dig1) + parseInt(dig2);
                            }
                            else
                                arr[i] = parseInt(dig);

                            total += parseInt(arr[i]);
                        }
                        else {
                            arr[i] = parseInt(numero[i]);
                            total += parseInt(arr[i]);
                        }
                    }
                }

                if (total % 10 == 0)
                    return this.inputVar.validation.status = true;
                else
                    return this.inputVar.validation = this.buildError('Cartão Inválido');
            },
            checkValidadeCard: function (data) {
                var mesInformado = data.split("/")[0];
                var anoInformado = '20' + data.split("/")[1];
                var MyData = new Date(anoInformado, mesInformado - 1, 1);

                if ((MyData.getMonth() + 1 != mesInformado) ||
                    (MyData.getFullYear() != anoInformado))
                    return this.inputVar.validation = this.buildError('Data inválida');
                else {
                    var mesCorrente = new Date().getMonth() + 1; //Janeiro é 0!
                    var anoCorrente = new Date().getFullYear();

                    if (anoInformado < anoCorrente)
                        return this.inputVar.validation = this.buildError('Data inválida');

                    if ((mesInformado < mesCorrente) && (anoInformado == anoCorrente))
                        return this.inputVar.validation = this.buildError('Data inválida');

                    return this.inputVar.validation.status = true
                }
                return this.inputVar.validation = this.buildError('Data inválida');
            }
        }
    }
</script>
